import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {SearchComplianceProposalModel} from '../models/search-compliance-proposal.model';
import {ComplianceProposalUpdateModel} from '../models/compliance-proposal-update.model';
import {ComplianceProposalHistoryModel} from '../models/compliance-proposal-history.model';
import {Pageable} from 'src/app/shared/models/pageable.model';
import {ComplianceProposalListModel} from '../models/compliance-proposal-list.model';
import {Observable} from 'rxjs';
import {ComplianceProposalDetailsModel} from '../models/compliance-proposal-details.model';
import {SearchComplianceProposalQueryModel} from "../models/search-compliance-proposal-query.model";

@Injectable({
  providedIn: 'root'
})
export class ComplianceProposalService {

  constructor(private http: HttpClient) {
  }

  findPendingProposals(filter: SearchComplianceProposalModel) {

    let query = new SearchComplianceProposalQueryModel();
    let sizeQuery = '';
    let pageQuery = '';

    if (filter) {
      sizeQuery = filter.size ? `&size=${filter.size}` : '';
      pageQuery = filter.page ? `&page=${filter.page}` : '';
      if (filter.startDate && filter.startDate !== '') {
        query.startDate = filter.startDate;
      }
      if (filter.endDate && filter.endDate !== '') {
        query.endDate = filter.endDate;
      }
      if (filter.cpfCnpj && filter.cpfCnpj !== '') {
        query.cpfCnpj = filter.cpfCnpj;
      }
      if (filter.institution && filter.institution !== '') {
        query.institution = filter.institution;
      }
      if (filter.serviceContract && filter.serviceContract !== '') {
        query.serviceContract = filter.serviceContract;
      }
    }
    let url = `${environment.apiUrls.compliancePendingProposals}?1=1${sizeQuery}${pageQuery}`;

    return this.http.post<Pageable<ComplianceProposalListModel[]>>(url, query);
  }

  findProposalHistory(filter: SearchComplianceProposalModel) {

    let query = new SearchComplianceProposalQueryModel();
    let sizeQuery = '';
    let pageQuery = '';

    if (filter) {
      sizeQuery = filter.size ? `&size=${filter.size}` : '';
      pageQuery = filter.page ? `&page=${filter.page}` : '';
      if (filter.startDate && filter.startDate !== '') {
        query.startDate = filter.startDate;
      }
      if (filter.endDate && filter.endDate !== '') {
        query.endDate = filter.endDate;
      }
      if (filter.cpfCnpj && filter.cpfCnpj !== '') {
        query.cpfCnpj = filter.cpfCnpj;
      }
      if (filter.institution && filter.institution !== '') {
        query.institution = filter.institution;
      }
      if (filter.serviceContract && filter.serviceContract !== '') {
        query.serviceContract = filter.serviceContract;
      }
      if (filter.status && filter.status !== '') {
        query.statusComplianceIdParam = filter.status;
      }
    }
    let url = `${environment.apiUrls.complianceProposalHistory}?1=1${sizeQuery}${pageQuery}`;

    return this.http.post<Pageable<ComplianceProposalHistoryModel[]>>(url, query);
  }

  setProposalStatus(data: ComplianceProposalUpdateModel) {
    return this.http.post<any>(`${environment.apiUrls.complianceProposalUpdate}`, data);
  }

  getProposalDetail(proposalNumber: string): Observable<ComplianceProposalDetailsModel> {
    return this.http.get<ComplianceProposalDetailsModel>(`${environment.apiUrls.complianceProposalDetail}/${proposalNumber}`);
  }
}
